import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Form as FormInitial,
  Tooltip,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  NotificacionMovimientosInventario,
  ButtonItem,
  ErrorItem,
  calcularMaxDisponible
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import ModalEtiquetaEntregaInsumo from "./ModalEtiquetaEntregaInsumo/ModalEtiquetaEntregaInsumo";
import {
  CalculatorOutlined,
  HourglassOutlined,
  CheckCircleOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  TagOutlined,
} from "@ant-design/icons";

const { Option } = Select;

moment.locale("es");

class EntregarInsumosPedido extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosPedido: undefined,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    id: this.props.location.state.pedidoId,
    colapsadoSinEntregar: false,
    colapsadoEntregados: true,
    filasConError: [],
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "pedidos/datosPedidoPRecibirP",
        {
          empresaId: this.props.empresaId,
          pedidoId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          this.setState({
            datosPedido: res.data.pedido,
            todasInsumos: res.data.insumos,
            todasProyectos: res.data.proyectos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
          const insumosFormato = res.data.pedido.insumos.map(value => {
            return {
              ...value,
              precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))),
              entregado: (value.entregado || 0),
            }
          });
          this.formRef.current.setFieldsValue({ insumos: insumosFormato });

          // Consulta de inventarios en bulk
          const insumosBulk = insumosFormato.map((row, index) => {
            const insumoOriginal = res.data.insumos.find(i => i._id.toString() === row.insumoId.toString());
            return {
              index,
              insumoId: row.insumoId,
              proyectoId: row.proyectoId,
              inventariable: insumoOriginal?.inventariable,
              noPrincipal: insumoOriginal?.noPrincipal,
              insumoCompuesto: insumoOriginal?.insumoCompuesto,
              componentesKit: row.componentesKit,
            };
          });
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              { empresaId: this.props.empresaId, insumos: insumosBulk, pedidoId: this.state.id },
              { headers: this.props.headersToken }
            );
            if (resInventarios.data?.results) {
              resInventarios.data.results.forEach(r => {
                insumosFormato[r.index].cantidadProyecto = r.cantidad !== null ? r.cantidad : "No inventariable";
              });
              this.formRef.current.setFieldsValue({ insumos: insumosFormato });
            }
          } catch (e) {
            console.error("Error al consultar inventario bulk", e);
          }
        } else {
          message.error(
            "Error no se encontro informacion del pedido"
          );
        }
      });
    this.setState({ loading: false });
  }

  // Para saber qué filas exceden lo permitido (pendiente del pedido o inventario del proyecto)
  calcularFilasConErrorInventario(insumos = []) {
    return (insumos || []).reduce((acc, row, index) => {
      const maxDisabled = calcularMaxDisponible({
        cantidad: this.state.datosPedido?.insumos?.[index]?.cantidad,
        yaMovido: this.state.datosPedido?.insumos?.[index]?.entregado,
        cantidadProyecto: row?.cantidadProyecto,
      });
      if ((row?.entregar || 0) > maxDisabled) acc.push(index);
      return acc;
    }, []);
  }
  onFinishFailed(e) {
    this.setState({ filasConError: this.calcularFilasConErrorInventario(this.formRef.current?.getFieldValue('insumos') || []) });
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ filasConError: [] });
    let entregarTodos = 0;
    values.insumos = values.insumos.map(value => {
      let entregar = value.entregar ? value.entregar : 0
      entregarTodos += entregar
      return { ...value, entregar }
    })
    if (entregarTodos === 0) return message.info('Se neceitan cantidades para poder hacer esta operación')
    this.setState({ loading: true });
    axios
      .post(
        "pedidos/entregarInsumos",
        {
          ...values,
          empresaId: this.props.empresaId,
          pedidoId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se han entregado insumos del pedido");
          NotificacionMovimientosInventario(res.data.movimientosIds)
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pueden entregar los insumos");
        } else {
          message.error("Hubo un error y no se entregaron los insumos");
        }
      });
  }
  atras() {
    this.props.history.push("/panel/verPedido", { id: this.state.id });
  }
  async onChangeInsumoProyecto(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyectoId = arrayValue[key].proyectoId;
    const insumoId = arrayValue[key].insumoId;
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === insumoId
    );
    if (!insumo) return
    if (insumo.inventariable || insumo.insumoCompuesto) {
      await axios
        .post(
          "inventarios/inventarioInsumoProyecto",
          {
            proyectoId: proyectoId,
            insumoId: insumoId,
            noPrincipal: insumo.noPrincipal,
            insumoCompuesto: insumo.insumoCompuesto,
            componentesKit: arrayValue[key].componentesKit,
            empresaId: this.props.empresaId,
            pedidoId: this.state.id,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          arrayValue[key].cantidadProyecto = res.data.cantidad;
        });
    } else {
      arrayValue[key].cantidadProyecto = "No inventariable";
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }
  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }
  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }
  abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirAgrupaciones: true,
        modalElegirAgrupacionesIndex: value,
        modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
        modalElegirAgrupacionesInsumoId: insumoId,
        modalElegirAgrupacionesProyectoId: proyectoId,
        modalElegirAgrupacionesClienteId: clienteId
      })
    } else {
      message.warning('Elegir un proyecto para elegir agrupaciones')
    }
  }
  cerrarElegirAgrupaciones(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirAgrupaciones: false,
      modalElegirAgrupacionesIndex: null,
      modalElegirAgrupacionesAgrupaciones: null,
      modalElegirAgrupacionesInsumoId: null,
      modalElegirAgrupacionesProyectoId: null,
      modalElegirAgrupacionesClienteId: null
    })
  }

  abrirEtiquetaEntrega(insumoId, cantidad, entregadoPrevio) {
    this.setState({
      modalEtiquetaEntrega: true,
      modalEtiquetaEntregaInsumoId: insumoId,
      modalEtiquetaEntregaCantidad: cantidad,
      modalEtiquetaEntregaEntregadoPrevio: entregadoPrevio || 0
    })
  }
  cerrarEtiquetaEntrega() {
    this.setState({
      modalEtiquetaEntrega: false,
      modalEtiquetaEntregaInsumoId: null,
      modalEtiquetaEntregaCantidad: null,
      modalEtiquetaEntregaEntregadoPrevio: null
    })
  }

  setMaxEntregarTodos = async () => {
    const form = this.formRef?.current;
    if (!form) return;
    this.setState({ loading: true });

    const insumos = form.getFieldValue("insumos") || [];

    const maxPorFila = insumos.map((row, idx) => calcularMaxDisponible({
      cantidad: this.state?.datosPedido?.insumos?.[idx]?.cantidad,
      yaMovido: this.state?.datosPedido?.insumos?.[idx]?.entregado,
      cantidadProyecto: row?.cantidadProyecto,
    }));

    const insumosConLotes = insumos
      .map((row, idx) => {
        const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
        if (!insumo?.lotesCaducidades || maxPorFila[idx] <= 0) return null;
        return { insumoId: row.insumoId, proyectoId: row.proyectoId, cantidad: maxPorFila[idx], _idx: idx };
      })
      .filter(Boolean);

    let resultadosMap = {};
    if (insumosConLotes.length > 0) {
      try {
        const res = await axios.post(
          "lotes/selectLotesDiponiblesMasivoRecomendadoConApartados",
          {
            empresaId: this.props.empresaId,
            insumos: insumosConLotes.map(({ insumoId, proyectoId, cantidad, _idx }) => ({ insumoId, proyectoId, cantidad, idx: _idx })),
            pedidoId: this.state.id,
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success === 2) {
          res.data.resultados.forEach((r) => {
            resultadosMap[r.idx] = r;
          });
        }
      } catch (e) {
        // Si falla, seguimos sin lotes automáticos
      }
    }

    const nuevos = insumos.map((row, idx) => {
      const resultado = resultadosMap[idx];
      let entregar = maxPorFila[idx];
      let extra = {};
      if (resultado) {
        entregar = Number(Math.min(entregar, resultado.cantidadCubierta));
        extra = { lotes: resultado.lotes };
      }
      return { ...row, entregar, ...extra };
    });

    form.setFieldsValue({ insumos: nuevos });
    this.setState({ loading: false });
  };

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Entregar Insumos sobre Pedido"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <h1>
              Fecha:{" "}
              {moment(this.state.datosPedido?.createdAt).format("LL")}
            </h1>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="entregarInsumosPedido"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Entregar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
              onValuesChange={(changedValues, allValues) => {
                if (this.state.filasConError.length > 0) {
                  this.setState({ filasConError: this.calcularFilasConErrorInventario(allValues.insumos) });
                }
              }}
            >
              <Row >
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Proyecto: {this.state.datosPedido?.proyecto.nombre}
                  </h1>
                  <p>
                    Descripcion:{" "}
                    {this.state.datosPedido?.proyecto.descripcion}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>Dirección</h1>
                  {this.state.datosPedido?.proyecto.calle ? (
                    <>
                      <p style={{ margin: 0 }}>
                        Calle: {this.state.datosPedido?.proyecto.calle}
                      </p>
                      <p style={{ margin: 0 }}>
                        Numero:{" "}
                        {this.state.datosPedido?.proyecto.numeroCalle}
                      </p>
                    </>
                  ) : (
                    <>
                      <p style={{ margin: 0 }}>
                        Marca: {this.state.datosPedido?.proyecto.marca}
                      </p>
                      <p style={{ margin: 0 }}>
                        Modelo: {this.state.datosPedido?.proyecto.modelo}
                      </p>
                      <p style={{ margin: 0 }}>
                        Placas: {this.state.datosPedido?.proyecto.placas}
                      </p>
                    </>
                  )}
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Cliente:{" "}
                    {this.state.datosPedido?.cliente.nombre
                      ? this.state.datosPedido?.cliente.nombre +
                      " " +
                      this.state.datosPedido?.cliente
                        .apellidoPaterno +
                      " " +
                      this.state.datosPedido?.cliente.apellidoMaterno
                      : this.state.datosPedido?.cliente.razonSocial}
                  </h1>
                  <p style={{ margin: 0 }}>
                    Rfc: {this.state.datosPedido?.cliente.rfc}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo: {this.state.datosPedido?.cliente.correo}
                  </p>
                  <p style={{ margin: 0 }}>
                    Telefono:{" "}
                    {this.state.datosPedido?.cliente.telefono}
                  </p>
                  <p style={{ margin: 0 }}>
                    Celular: {this.state.datosPedido?.cliente.celular}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <p style={{ margin: 0 }}>
                    Contacto:{" "}
                    {this.state.datosPedido?.cliente.nombreContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Tel. Contacto:{" "}
                    {this.state.datosPedido?.cliente.telefonoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo Contacto:{" "}
                    {this.state.datosPedido?.cliente.correoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Dias de crédito:{" "}
                    {this.state.datosPedido?.cliente.diasCredito}
                  </p>
                </Col>
              </Row>
              <Divider style={{ marginBottom: 10, marginTop: 5 }} />
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "20%" }}>
                                Insumo
                              </th>
                              <th className="th-border" style={{ width: "20%" }}>
                                Proyecto
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Cantidad Proyecto
                              </th>
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Pedida
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Entregada
                                </th>
                              }
                              <th className="th-border" style={{ width: "10%", textAlign: "center" }}>
                                Cantidad a entregar
                                <Tooltip title="Poner máximos">
                                  <CalculatorOutlined onClick={this.setMaxEntregarTodos} style={{ marginLeft: 5, color: 'green', cursor: 'pointer' }} />
                                </Tooltip>
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Accion
                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {(() => {
                          const pendientes = [];
                          const entregados = [];
                          fields.forEach((field, arrayKey) => {
                            const insumoPedido = this.state.datosPedido?.insumos?.[arrayKey];
                            const cantidad = Number(insumoPedido?.cantidad) || 0;
                            const entregado = Number(insumoPedido?.entregado) || 0;
                            if (cantidad - entregado <= 0) {
                              entregados.push({ field, arrayKey, isEntregado: true });
                            } else {
                              pendientes.push({ field, arrayKey, isEntregado: false });
                            }
                          });
                          const renderFila = ({ field, arrayKey, isEntregado }) => {
                            const { key, name, fieldKey, ...restField } = field;
                            return (
                          <FormItem key={fieldKey} noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                              const row = (getFieldValue('insumos') || [])[arrayKey];
                              const lotes = row?.lotes || [];
                              const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
                              const necesitaLotes = insumo?.lotesCaducidades;
                              const entregar = row?.entregar || 0;
                              const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
                              const isRed = necesitaLotes && entregar > 0 && sumLotes !== entregar;
                              const tieneErrorInventario = (this.state.filasConError || []).includes(arrayKey);
                              return (
                          <tbody style={isEntregado && !isRed && !tieneErrorInventario ? { backgroundColor: '#f5f5f5', opacity: 0.85 } : {}}>
                            <tr
                              className={tieneErrorInventario ? 'fila-insumo-conflicto' : ''}
                              style={!tieneErrorInventario && isRed ? { backgroundColor: '#ffccc7' } : {}}
                            >
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "insumoId"]}
                                  fieldKey={[fieldKey, "insumoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Insumo"
                                    disabled
                                  >
                                    {this.state.objetoInsumos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "proyectoId"]}
                                  fieldKey={[fieldKey, "proyectoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Proyecto"
                                    onChange={(value) =>
                                      this.onChangeInsumoProyecto(
                                        value,
                                        arrayKey
                                      )
                                    }
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidadProyecto"]}
                                  required
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    disabled
                                    placeholder="Cantidad en Proyecto"
                                  />
                                </FormItem>
                              </td>
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidad"]}
                                  fieldKey={[fieldKey, "cantidad"]}
                                  required
                                  number
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Pedida"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "entregado"]}
                                  fieldKey={[fieldKey, "entregado"]}
                                  required
                                  numberCero
                                  noStyle
                                  initialValue={0}
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Entregada"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              <td className="td-border">
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    // arrayKey en ambas lecturas: antes el pedido se
                                    // indexaba con fieldKey y cantidadProyecto con
                                    // arrayKey. Hoy coinciden, pero son dos indices
                                    // distintos de Form.List.
                                    const filaPedido =
                                      this.state?.datosPedido?.insumos?.[arrayKey];
                                    const insumos = getFieldValue("insumos");
                                    const maxDisabled = calcularMaxDisponible({
                                      cantidad: filaPedido?.cantidad,
                                      yaMovido: filaPedido?.entregado,
                                      cantidadProyecto: insumos?.[arrayKey]?.cantidadProyecto,
                                    });
                                    return (
                                      <FormItem
                                        {...restField}
                                        name={[name, "entregar"]}
                                        fieldKey={[fieldKey, "entregar"]}
                                        numberCero
                                        noStyle
                                        max={maxDisabled}
                                        type="number"
                                      >
                                        <InputNumberItem
                                          sinBorde
                                          placeholder={"Max: " + maxDisabled}
                                        />
                                      </FormItem>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <Row>
                                  <Col span={24}>
                                    <FormItem
                                      noStyle
                                      shouldUpdate
                                    >
                                      {({ getFieldValue }) => {
                                        let arrayValue = getFieldValue("insumos");
                                        let mostrarMarbetes = false
                                        let mostrarLotes = false
                                        let mostrarAgrupaciones = false
                                        let insumoId
                                        let proyectoId
                                        if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                          const insumo = this.state.todasInsumos.find(
                                            (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                          );
                                          mostrarMarbetes = insumo?.marbetes
                                          mostrarLotes = insumo?.lotesCaducidades
                                          mostrarAgrupaciones = insumo?.agrupaciones
                                          insumoId = insumo?._id
                                          proyectoId = arrayValue[arrayKey]?.proyectoId
                                        }
                                        const entregar = arrayValue[arrayKey]?.entregar
                                        const entregado = arrayValue[arrayKey]?.entregado || 0
                                        const cantidadEtiqueta = entregar > 0 ? entregar : entregado
                                        const maxDisabledEtiqueta = calcularMaxDisponible({
                                          cantidad: this.state?.datosPedido?.insumos?.[arrayKey]?.cantidad,
                                          yaMovido: this.state?.datosPedido?.insumos?.[arrayKey]?.entregado,
                                          cantidadProyecto: arrayValue[arrayKey]?.cantidadProyecto,
                                        })
                                        const excedeMaxEtiqueta = entregar > 0 && entregar > maxDisabledEtiqueta
                                        const botones = [];
                                        if (mostrarMarbetes) {
                                          botones.push(
                                            <ButtonItem
                                              key="mar"
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)
                                              }}
                                            >
                                              Mar.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarAgrupaciones) {
                                          botones.push(
                                            <ButtonItem
                                              key="agr"
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)
                                              }}
                                            >
                                              Agr.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarLotes) {
                                          botones.push(
                                            <ButtonItem
                                              key="lot"
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].entregar)
                                              }}
                                            >
                                              {this.props.taxidermia ? "Animales" : "Lotes"}
                                            </ButtonItem>
                                          )
                                        }
                                        if (cantidadEtiqueta > 0 && this.props.activarEtiquetaEntregaPedido) {
                                          const esReimpresion = !(entregar > 0)
                                          const permiteEtiquetaSinInventario = this.props.permisoEtiquetaSinInventario
                                          const etiquetaDeshabilitada = excedeMaxEtiqueta && !permiteEtiquetaSinInventario
                                          const tooltipEtiqueta = excedeMaxEtiqueta
                                            ? (permiteEtiquetaSinInventario
                                              ? `La cantidad a entregar (${entregar}) excede el inventario disponible (${maxDisabledEtiqueta}). Se genera como preentrega, sin afectar el inventario.`
                                              : `La cantidad a entregar (${entregar}) excede lo permitido (${maxDisabledEtiqueta})`)
                                            : esReimpresion
                                              ? `No hay cantidad nueva capturada: esto reimprime la etiqueta de lo ya entregado (${entregado})`
                                              : `Genera etiquetas para esta entrega nueva (${entregar})`
                                          botones.push(
                                            <Tooltip key="etq" title={tooltipEtiqueta}>
                                              <ButtonItem
                                                type="primary"
                                                morado
                                                size='small'
                                                disabled={etiquetaDeshabilitada}
                                                style={{ width: '80%', marginLeft: '10%', marginTop: botones.length > 0 ? 4 : 0 }}
                                                block
                                                icon={<TagOutlined />}
                                                onClick={() => {
                                                  this.abrirEtiquetaEntrega(insumoId, cantidadEtiqueta, entregado)
                                                }}
                                              >
                                                {esReimpresion ? `Reimprimir (${entregado})` : "Etiquetas"}
                                              </ButtonItem>
                                            </Tooltip>
                                          )
                                        }
                                        return botones;
                                      }}
                                    </FormItem>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                              );
                            }}
                          </FormItem>
                            );
                          };
                          return (
                            <>
                              {pendientes.length > 0 && (
                                <tbody>
                                  <tr>
                                    <td colSpan="7" style={{ padding: 0, border: 'none' }}>
                                      <div
                                        onClick={() => this.setState({ colapsadoSinEntregar: !this.state.colapsadoSinEntregar })}
                                        style={{
                                          background: "#e6f7ff", borderLeft: "4px solid #1890ff",
                                          padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                          fontWeight: "bold", color: "#0050b3", marginTop: 10, marginBottom: 5
                                        }}
                                      >
                                        <span><HourglassOutlined style={{ marginRight: 8 }} /> Sin entregar / Incompletos ({pendientes.length})</span>
                                        <span>{this.state.colapsadoSinEntregar ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                              {!this.state.colapsadoSinEntregar && pendientes.map(renderFila)}

                              {entregados.length > 0 && (
                                <tbody>
                                  <tr>
                                    <td colSpan="7" style={{ padding: 0, border: 'none' }}>
                                      <div
                                        onClick={() => this.setState({ colapsadoEntregados: !this.state.colapsadoEntregados })}
                                        style={{
                                          background: "#f6ffed", borderLeft: "4px solid #52c41a",
                                          padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                          fontWeight: "bold", color: "#237804", marginTop: 10, marginBottom: 5
                                        }}
                                      >
                                        <span><CheckCircleOutlined style={{ marginRight: 8 }} /> Entregados completamente ({entregados.length})</span>
                                        <span>{this.state.colapsadoEntregados ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                              {!this.state.colapsadoEntregados && entregados.map(renderFila)}
                            </>
                          );
                        })()}
                      </table>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          ventaId={this.state.id}
          cantidad={this.state.modalElegirLotesCantidad}
          modoCantidad="exacta"
        />
        <ElegirAgrupaciones
          visible={this.state.modalElegirAgrupaciones}
          cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
          agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
          insumoId={this.state.modalElegirAgrupacionesInsumoId}
          proyectoId={this.state.modalElegirAgrupacionesProyectoId}
          clienteId={this.state.modalElegirAgrupacionesClienteId}
          ventaId={this.state.id}
        />
        <ModalEtiquetaEntregaInsumo
          visible={this.state.modalEtiquetaEntrega}
          insumoId={this.state.modalEtiquetaEntregaInsumoId}
          cantidadEntregar={this.state.modalEtiquetaEntregaCantidad}
          entregadoPrevio={this.state.modalEtiquetaEntregaEntregadoPrevio}
          clienteId={this.state.datosPedido?.cliente?._id}
          pedidoId={this.state.id}
          cerrarModal={this.cerrarEtiquetaEntrega.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
    activarEtiquetaEntregaPedido: state.empresa.activarEtiquetaEntregaPedido,
    permisoEtiquetaSinInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find((p) => p.permisoId.toString() === "6aa08f0cee88a932beca538d")?.activado,
  };
};

export default connect(mapStateToProps)(EntregarInsumosPedido);
